// every area of the dashboard's texts (en)
import admin from './admin'
import auth from './auth'
import common from './common'
import dashboard from './dashboard'
import devices from './devices'
import messaging from './messaging'
import monitoring from './monitoring'
import nav from './nav'
import profile from './profile'
import rental from './rental'
import settings from './settings'
import sites from './sites'
import starlink from './starlink'
import subscriptions from './subscriptions'
import templates from './templates'
import users from './users'

export default { ...admin, ...auth, ...common, ...dashboard, ...devices, ...messaging, ...monitoring, ...nav, ...profile, ...rental, ...settings, ...sites, ...starlink, ...subscriptions, ...templates, ...users }
